// source: pushwoosh/referral_partners/referral-partners.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_api_annotations_pb = require('../../google/api/annotations_pb.js');
goog.object.extend(proto, google_api_annotations_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.CreateRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.CreateResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest', null, global);
goog.exportSymbol('proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.CreateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.CreateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.CreateResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.CreateResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.repeatedFields_, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.displayName = 'proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.GetRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    referralHash: jspb.Message.getFieldWithDefault(msg, 1, ""),
    withdrawalInfo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.GetResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setReferralHash(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setWithdrawalInfo(value);
      break;
    case 3:
      var value = /** @type {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReferralHash();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getWithdrawalInfo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status = {
  UNKNOWN: 0,
  ACTIVE: 1,
  BLOCKED: 2
};

/**
 * optional string referral_hash = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.getReferralHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.setReferralHash = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string withdrawal_info = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.getWithdrawalInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.setWithdrawalInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional Status status = 3;
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.getStatus = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse.Status} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.CreateRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.CreateResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    withdrawalsList: jspb.Message.toObjectList(msg.getWithdrawalsList(),
    proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.deserializeBinaryFromReader);
      msg.addWithdrawals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWithdrawalsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.serializeBinaryToWriter
    );
  }
};


/**
 * @enum {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status = {
  UNKNOWN: 0,
  CREATED: 1,
  IN_PROCESS: 2,
  SUCCESS: 3,
  ERROR: 4
};




if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.toObject = function(includeInstance, msg) {
  var f, obj = {
    date: (f = msg.getDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0),
    withdrawalInfo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    amount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal;
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 2:
      var value = /** @type {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setWithdrawalInfo(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getWithdrawalInfo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp date = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.getDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} returns this
*/
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.hasDate = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional Status status = 2;
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.getStatus = function() {
  return /** @type {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Status} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string withdrawal_info = 3;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.getWithdrawalInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.setWithdrawalInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint64 amount = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal.prototype.setAmount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated Withdrawal withdrawals = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal>}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.getWithdrawalsList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal>} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse} returns this
*/
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.setWithdrawalsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.addWithdrawals = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.Withdrawal, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalsHistoryResponse.prototype.clearWithdrawalsList = function() {
  return this.setWithdrawalsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    expectedRevenues: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    availableRevenues: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    totalRevenues: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    membersCount: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setExpectedRevenues(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAvailableRevenues(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalRevenues(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setMembersCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExpectedRevenues();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getAvailableRevenues();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTotalRevenues();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getMembersCount();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
};


/**
 * optional double expected_revenues = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.getExpectedRevenues = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.setExpectedRevenues = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double available_revenues = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.getAvailableRevenues = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.setAvailableRevenues = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double total_revenues = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.getTotalRevenues = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.setTotalRevenues = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional uint64 members_count = 4;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.getMembersCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetTotalStatisticsResponse.prototype.setMembersCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    withdrawalInfo: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setWithdrawalInfo(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getWithdrawalInfo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string withdrawal_info = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.prototype.getWithdrawalInfo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoRequest.prototype.setWithdrawalInfo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.UpdateWithdrawalInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
};


/**
 * optional double amount = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.CreateWithdrawalResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    currency: jspb.Message.getFieldWithDefault(msg, 2, ""),
    withForm: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setWithForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getWithForm();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional double amount = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional string currency = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool with_form = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.getWithForm = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoRequest.prototype.setWithForm = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalFee: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    sourceAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    targetAmount: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    targetCurrency: jspb.Message.getFieldWithDefault(msg, 4, ""),
    form: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTotalFee(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSourceAmount(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTargetAmount(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTargetCurrency(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setForm(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalFee();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getSourceAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getTargetAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTargetCurrency();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getForm();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional double total_fee = 1;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.getTotalFee = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.setTotalFee = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double source_amount = 2;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.getSourceAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.setSourceAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double target_amount = 3;
 * @return {number}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.getTargetAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.setTargetAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional string target_currency = 4;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.getTargetCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.setTargetCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string form = 7;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.getForm = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetWithdrawalAdditionalInfoResponse.prototype.setForm = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest;
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    currenciesList: jspb.Message.toObjectList(msg.getCurrenciesList(),
    proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse;
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency;
      reader.readMessage(value,proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.deserializeBinaryFromReader);
      msg.addCurrencies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCurrenciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.serializeBinaryToWriter
    );
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.toObject = function(opt_includeInstance) {
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.toObject = function(includeInstance, msg) {
  var f, obj = {
    code: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    supportsDecimals: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency;
  return proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCode(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSupportsDecimals(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCode();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSupportsDecimals();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string code = 1;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.getCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.setCode = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool supports_decimals = 3;
 * @return {boolean}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.getSupportsDecimals = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency.prototype.setSupportsDecimals = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * repeated Currency currencies = 1;
 * @return {!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency>}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.getCurrenciesList = function() {
  return /** @type{!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency, 1));
};


/**
 * @param {!Array<!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency>} value
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse} returns this
*/
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.setCurrenciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency=} opt_value
 * @param {number=} opt_index
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency}
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.addCurrencies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.Currency, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse} returns this
 */
proto.pushwoosh.rpc_v2.referral_partners.GetCurrenciesResponse.prototype.clearCurrenciesList = function() {
  return this.setCurrenciesList([]);
};


goog.object.extend(exports, proto.pushwoosh.rpc_v2.referral_partners);
